<template>
  <div class="group_experiment_board ma-0">    
    <v-text-field v-model='par' v-if="0"></v-text-field>
    <v-expansion-panels class="my-3" v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header color="green lighten-5">
          <h5>{{ $t("group_experiment.ongoing.header") }}</h5>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col v-if="api.no_record == true">
              {{ $t("group_experiment.ongoing.no_record") }}
            </v-col>
            <v-col
              v-else-if="api.no_record == false"
              v-for="(item, index) in api.group_experiment_slots" :key="index" cols="12" sm="6" md="4">
              <v-card class="mx-auto" max-width="350px">
                 <v-img 
                  height="320px"
                  class="d-flex align-end"
                  cover
                  :src="expPhoto(item.experiment)"
                  :alt="item.experiment_set"
                >
                </v-img>
                <v-card-title v-if="$i18n.locale=='tc'">
                  {{ item.experiment_set_chi }}
                </v-card-title>
                <v-card-title v-else>
                  {{ item.experiment_set }}
                </v-card-title>

                <div class="text-body-2 pl-6 mt-n4">
                  <table>
                    <tr>
                      <td>{{ $t("group_experiment.ongoing.start") }}</td>
                      <td class="pl-2">{{ item.start_datetime }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t("group_experiment.ongoing.end") }}</td>
                      <td class="pl-2">{{ item.actual_end_time }}</td>
                    </tr>
                  </table>
                </div>

                <v-card-actions>
                  <v-btn v-if="!item.show" rounded text @click="item.show = !item.show">{{ $t("group_experiment.ongoing.see_more") }}<v-icon>mdi-chevron-down</v-icon></v-btn>
                  <v-btn v-else rounded text @click="item.show = !item.show">{{ $t("group_experiment.ongoing.show_less") }}<v-icon>mdi-chevron-up</v-icon></v-btn>
                  <v-spacer></v-spacer>
                  <div>
                    <v-icon v-if="(item.eStatus=='HOLD')" color="red" >mdi-alert-circle</v-icon>
                    <v-btn
                      color="primary"
                      :disabled="item.eStatus=='HOLD'"
                      @click="enterGroupLab(item, 'player')"
                    >
                      {{ $t("group_experiment.btn.enter_lab") }}
                    </v-btn>
                  </div>
                </v-card-actions>
                <v-row class="text-right">
                  <v-col class="pt-0">
                    <div v-if="item.eStatus=='HOLD' && (current.user_level == 'TEACHER' || current.user_level=='ADMIN')">
                      <v-btn
                        color="error"
                        text
                        :disabled="item.eStatus=='ACTIVE'"
                        @click="enterGroupLab(item, 'overrider')"
                      >
                        {{ $t("group_experiment.ongoing.btn_force_enter") }}
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-expand-transition>
                  <div v-if="item.config!=null" v-show="item.show">
                    <v-divider class="mt-2 mx-5"></v-divider>
                    <v-card-text class="pt-0 text-body-1 font-weight-bold">
                      Experiment Setting:
                      <div class="text-body-2 px-auto">
                        <table>
                          <tr v-for="(value, key) in item.config" :key="key">
                            <td>{{ key }}:</td>
                            <td class="pl-2">{{ value }}</td>
                          </tr>
                        </table>
                      </div>
                    </v-card-text>
                  </div>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="dialog_calendar" fullscreen hide-overlay>
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_calendar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("booking.calendar.dialog_title") }}</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>


import {api_dds_general} from '@/services/dds/api_dds_general';
const apiDDSGeneral = new api_dds_general(process.env.VUE_APP_BASE_URL);

import {api_dds_booking} from '@/services/dds/api_dds_booking';
const apiDDSBooking = new api_dds_booking(process.env.VUE_APP_BASE_URL);

import Calendar from '@/components/booking/Calendar.vue'

export default {
  name: "group_experiment_board",
  components: {
    Calendar
  },
  props: {
    par: String,
  },
  mixins: [],
  data: function () {
    return {
      panel: [0],
      school_code: "",
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      dialog_calendar: false,
      current:{
        school_code: null,
        username: null,
        user_level: "STUDENT",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      form: {
        school: "",
        experiment: "",
        equipment_id: "",
        next: "",
      },
      api:{
        schools:[],
        experiments:[],
        book_slots: [],
        group_experiment_slots: [],
        slots: [],
        school_code: '',
        school_name: '',
        school_chi_name: '',
        school_logo_url: '',
        no_record: false,
      },
      headers_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'Experiment Set', value: 'experiment_set' },
        { text: 'From', value: 'start_at' },
        { text: 'To', value: 'end_at' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },        
      ],
      headers_slots_chi: [
        { text: '參考編號', value: 'ref' },
        { text: '實驗組', value: 'experiment_set_chi' },
        { text: '開始', value: 'start_at' },
        { text: '結束', value: 'end_at' },
        { text: '狀態', value: 'status_chi' },
        { text: '操作', value: 'actions', sortable: false },        
      ],
      headers_book_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'Experiment Set', value: 'experiment_set' },
        { text: 'Date', value: 'date' },
        { text: 'Time', value: 'time' },
        { text: 'Duration (mins)', value: 'duration' },
        { text: 'Status', value: 'status' },
        { text: 'Update At', value: 'update_at' },
        //{ text: 'Actions', value: 'actions', sortable: false },        
      ],
      headers_book_slots_chi: [
        { text: '參考編號', value: 'ref' },
        { text: '實驗組', value: 'experiment_set_chi' },
        { text: '日期', value: 'date' },
        { text: '時間', value: 'time' },
        { text: '時長(分鐘)', value: 'duration' },
        { text: '狀態', value: 'status_chi' },
        { text: '最後更新', value: 'update_at' },
        //{ text: 'Actions', value: 'actions', sortable: false },        
      ],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_code = self.$store.state.user.school_code;
    self.current.username = self.$store.state.user.username;
    self.current.uid = self.$store.state.user.uid;    
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.school_code = self.$route.params.school_code;
    self.experiment = self.$route.query.experiment;
    self.equipment_id = self.$route.query.equipment;
    if(self.experiment!=undefined && self.equipment_id != undefined){
      if(self.$i18n.locale=='tc'){
        self.selected_experiment = self.experimentNameTranslate[self.experiment] + " - " + self.setTranslate[self.equipment_id];
      }
      else {
        self.selected_experiment = self.experiment.toUpperCase() + " - " + self.equipment_id;
      }
    }
    //self.form.school = self.school_code;
    self.getSchoolInfo();
    self.checkAuthorized();
    self.getOngoingGroupExperimentByUserRight();
  },
  methods: {
    init(){
      var self = this;
      console.log(self.$route.params.school_code);
      self.current.school_code = self.$store.state.user.school_code;
      self.current.username = self.$store.state.user.username;
      self.current.uid = self.$store.state.user.uid;
      self.current.user_level = self.$store.state.user.user_level;
      self.current.auth_token = self.$store.state.user.auth_token;
      self.form.school_code = self.$route.params.school_code;
      if(self.current.user_level == "STUDENT"){
        //self.panel = "1";
      }
      if(self.current.user_level != "ADMIN" ){
        self.api.schools = [self.current.school_code];
        self.form.school_code = self.current.school_code;
        self.getUserAuthSchool();
      }
      else {
        self.getFullSchoolList();
        if(self.$route.params.school_code == undefined){
          self.form.school_code = self.current.school_code;
          self.$router.push("/group_experiment_board/"+self.current.school_code);
        }
        else {
          self.form.school_code = self.$route.params.school_code;
          self.$router.push("/group_experiment_board/"+self.form.school_code);
        }
      }      
      self.getSchoolInfo();
      self.getOngoingGroupExperimentByUserRight();
    },
    getUserAuthSchool(){
      var self = this;
      apiDDSGeneral.getUserAuthSchool(self.current.school_code, self.current.username, self.current.uid).then((response) => {
        //if(response.status=="success" && self.$route.params.school_code!=response.school){
        //  self.$router.push("/booking/"+response.school+"/");
        //}
        if(response.schools.length < 1){
          self.$store.commit("showSnackBar", "Fail to retrieve school info. Please try again.");
          self.$router.push("/");
        }
        if(self.$route.params.school_code == undefined){
          self.$router.push("/group_experiment_board/"+response.my_school+"/");
        }
        let hasRight = self.my_schools.find(school => school.school === self.$route.params.school_code);
        if(hasRight == undefined){
          self.$router.push("/group_experiment_board/"+response.my_school+"/");
        }
      });
    },    
    checkAuthorized: function(){
      var self = this;
      let user_level = self.$store.state.user.user_level;
      let user_school = self.$store.state.user.school_code;
      if(  ( (user_level=="TEACHER") && user_school==self.school_code ) ||  user_level=="ADMIN" ){
        self.authorized = true;
      }
      else {
        self.authorized = false;
      }
    },
    getFullSchoolList(){
      var self = this;
      apiDDSGeneral.getFullSchoolList()
        .then((response) => {
          self.api.schools = response.schools;
      });
    },
    expPhoto(experiment){
      var self = this;      
      if(self.$i18n.locale=='tc') {
        if(experiment == 'ENVIRONMENTAL_MONITORING'){
          return "https://stem-ap.polyu.edu.hk/remotelab/assets/images/environmental-monitoring-ch-596x596.png";
        }
        else if(experiment == 'PHOTOSYNTHESIS'){
          return "https://stem-ap.polyu.edu.hk/remotelab/assets/images/slide7-720x720.png";
        }
        else if(experiment == 'RESPIRATION'){
          return "https://stem-ap.polyu.edu.hk/remotelab/assets/images/slide8-1-720x720.png";
        }
      }
      else {
        if(experiment == 'ENVIRONMENTAL_MONITORING'){
          return "https://stem-ap.polyu.edu.hk/remotelab/assets/images/environment20monitoring-596x596.png";
        }
        else if(experiment == 'PHOTOSYNTHESIS'){
          return "https://stem-ap.polyu.edu.hk/remotelab/assets/images/slide10-596x596.png";
        }
        else if(experiment == 'RESPIRATION'){
          return "https://stem-ap.polyu.edu.hk/remotelab/assets/images/resp-1-596x596.png";
        }
      }
    },
    getSchoolInfo(){
      var self = this;
      apiDDSBooking.getSchoolInfo(self.school_code)
      .then((response) => {
          self.api.school_code = response.school;
          self.api.school_enname = response.school_enname;
          self.api.school_chname = response.school_chname;
          if(JSON.parse(response.school_logo)!=null){
            self.api.school_logo_url = JSON.parse(response.school_logo).url;
          }
          else {
            self.api.school_logo_url = "";
          }
          console.log(self.api.school_enname = response.school_enname,
          self.api.school_chname = response.school_chname);
          self.$emit("info", {school_code: self.api.school_code, school_enname: self.api.school_enname, school_chname: self.api.school_chname, school_logo_url: self.api.school_logo_url});
      });
    },
    getOngoingGroupExperimentByUserRight(){
      var self = this;
      apiDDSBooking.getOngoingGroupExperimentByUserRight(self.school_code, self.current.uid)
      .then((response) => {      
          self.api.group_experiment_slots = response.group_experiment_slots;
          if(response.record_no == 0){
            self.api.no_record = true;
          }
      });
    },
    enterGroupLab: function (item, role) {
      var self = this;
      apiDDSBooking.enterGroupLab(item.ref, self.$cookies.get("uid"), self.school_code , item.experiment, item.equipment_id, self.$cookies.get("auth_token"), role, self.$cookies.get("user_level"))
        .then((response) => {
          if (response.status == "fail") {
            self.$store.commit("showSnackBar", response.message);
            self.getExperimentList();
          } else {
            if(self.$i18n.locale=='tc')
              self.$store.commit("showSnackBar", "準備中...");
            else
              self.$store.commit("showSnackBar", "Preparing...");
              self.$cookies.set("session_token", response.session_token);
              self.$cookies.set("role", role);
              self.$cookies.set("school_code", self.school_code);
              self.$cookies.set("experiment", item.experiment);
              self.$cookies.set("equipment_id", item.equipment_id);
              self.$cookies.set("end_at", response.end_at);
              self.$cookies.set("group_slot_id", item.ref);
              self.$router.push("/group_experiment/" + self.school_code + "/" + item.experiment.toLowerCase() + "/" + item.equipment_id);
          }
        });
    },
  },
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
v-btn {
  text-transform: none;
}
</style>